import axios from "axios";

//const severUrl = "https://www.centralglobalbackend.de/";
const severUrl = "https://www.hotanloc.com/";
//const severUrl = "http://127.0.0.1:8000/"

export const saveHTML = async (slug, abstract, content) => {
  try {
    var bodyFormData = new FormData();
    bodyFormData.append("slug", slug);
    bodyFormData.append("abstract", abstract);
    bodyFormData.append("content", content);
    const resp = await axios.post(
      severUrl + "blog/html/save/",
      bodyFormData
    );
    // console.log(resp);
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const getHTML = async (slug) => {
  try {
    var bodyFormData = new FormData();
    bodyFormData.append("slug", slug);
    const resp = await axios.post(
      severUrl + "blog/html/get/",
      bodyFormData
    );
    // console.log(resp);
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const toHTML = async (slug) => {
  try {
    var bodyFormData = new FormData();
    bodyFormData.append("slug", slug);
    const resp = await axios.post(
      severUrl + "blog/html/to/",
      bodyFormData
    );
    //console.log(resp);
    return resp;
  } catch (err) {
    console.error(err);
  }
};


export const getStories = async () => {
  axios.post(severUrl + "blog/post/story/").then((response) => {
    return response;
  });
};

export const getComments = async (slug) => {
  axios.get(severUrl + "blog/" + slug + "/comments/").then((response) => {
    return response.json();
  });
};

export const createComment = async (email, text, reply_to = null, slug) => {
  try {
    var bodyFormData = new FormData();
    bodyFormData.append("text", text);
    bodyFormData.append("email", email);
    bodyFormData.append("reply_to", reply_to);
    const resp = await axios.post(
      severUrl + "blog/" + slug + "/create/comments/",
      bodyFormData
    );
    // console.log(resp);
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const updateComment = async (text, commentId, slug) => {
  try {
    var bodyFormData = new FormData();
    bodyFormData.append("id", commentId);
    bodyFormData.append("text", text);
    const resp = await axios.post(
      severUrl + "blog/" + slug + "/update/comments/",
      bodyFormData
    );
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const deleteComment = async (commend_id, slug) => {
  try {
    var bodyFormData = new FormData();
    bodyFormData.append("id", commend_id);
    const resp = await axios.post(
      severUrl + "blog/" + slug + "/delete/comments/",
      bodyFormData
    );
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const adminDeletePost = async (slug) => {
  try {
    var bodyFormData = new FormData();
    bodyFormData.append("slug", slug);
    const resp = await axios.post(
      severUrl + "blog/admin/deletepost/",
      bodyFormData
    );
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const adminSetNext = async (slug, nextSlug) => {
  try {
    var bodyFormData = new FormData();
    bodyFormData.append("slug", slug);
    bodyFormData.append("nextSlug", nextSlug);
    const resp = await axios.post(
      severUrl + "blog/admin/setnext/",
      bodyFormData
    );
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const adminSetPre = async (slug, preSlug) => {
  try {
    var bodyFormData = new FormData();
    bodyFormData.append("slug", slug);
    bodyFormData.append("preSlug", preSlug);
    const resp = await axios.post(
      severUrl + "blog/admin/setprevious/",
      bodyFormData
    );
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const removeTag = async (tag, post) => {
  try {
    var bodyFormData = new FormData();
    bodyFormData.append("tag", tag);
    bodyFormData.append("post", post);
    const resp = await axios.post(
      severUrl + "blog/admin/removetag/",
      bodyFormData,
      {
        headers: {
          accept: "application/json",
          "Accept-Language": "en-US,en;q=0.8",
          "Content-Type": `multipart/form-data; boundary=${bodyFormData._boundary}`,
        },
      }
    );
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const adminSave = async (
  title,
  abstract,
  status,
  eng_ver,
  thumnail,
  tag,
  slug,
  video = null,
  pdf = null,
  topic = null,
  ava = null,
  features = null,
  modelLink = "",
  staticValue = 0,
  currVer = 1
) => {
  try {
    var bodyFormData = new FormData();

    bodyFormData.append("staticValue", staticValue);

    if (title) {
      bodyFormData.append("title", title);
    }

    if (abstract) {
      bodyFormData.append("abstract", abstract);
    }

    if (status) {
      bodyFormData.append("status", status);
    }

    if (eng_ver) {
      bodyFormData.append("eng_ver", slug);
    }

    if (slug) {
      bodyFormData.append("slug", slug);
    }

    if (thumnail instanceof Blob) {
      bodyFormData.append("thumnail", thumnail, thumnail.filename);
    }

    if (ava) {
      bodyFormData.append("ava", ava);
    }

    if (video) {
      bodyFormData.append("video", video);
    }

    if (pdf instanceof Blob) {
      bodyFormData.append("pdf", pdf, pdf.name);
    }

    if (topic) {
      bodyFormData.append("topic", topic);
    }

    if (features == null || features == "") {
      bodyFormData.append("features", features);
    } else {
      bodyFormData.append("features", "{}");
    }
    if (modelLink) {
      bodyFormData.append("modelLink", modelLink);
    } else {
      bodyFormData.append("modelLink", "");
    }


    bodyFormData.append("ver", currVer);

    const tag_json = { data: tag };
    bodyFormData.append("tag", JSON.stringify(tag_json));
    const resp = await axios.post(severUrl + "blog/admin/side/", bodyFormData, {
      headers: {
        accept: "application/json",
        "Accept-Language": "en-US,en;q=0.8",
        "Content-Type": `multipart/form-data; boundary=${bodyFormData._boundary}`,
      },
    });
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const adminSaveModel = async (
  features = "{}",
  modelLink = "",
  slug = null
) => {
  try {
    var bodyFormData = new FormData();

    if (features) {
      bodyFormData.append("features", features);
    } else {
      bodyFormData.append("features", "{}");
    }

    if (modelLink) {
      bodyFormData.append("modelLink", modelLink);
    } else {
      bodyFormData.append("modelLink", "");
    }

    if (slug) {
      bodyFormData.append("slug", slug);
    }

    const resp = await axios.post(
      severUrl + "blog/admin/saveModel/",
      bodyFormData,
      {
        headers: {
          accept: "application/json",
          "Accept-Language": "en-US,en;q=0.8",
          "Content-Type": `multipart/form-data; boundary=${bodyFormData._boundary}`,
        },
      }
    );
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const adminRemoveTag = async (tag, slug) => {
  try {
    var bodyFormData = new FormData();
    bodyFormData.append("tag", tag);
    bodyFormData.append("slug", slug);
    const resp = await axios.post(
      severUrl + "blog/admin/removetag/",
      bodyFormData,
      {
        headers: {
          accept: "application/json",
          "Accept-Language": "en-US,en;q=0.8",
          "Content-Type": `multipart/form-data; boundary=${bodyFormData._boundary}`,
        },
      }
    );
    return resp;
  } catch (err) {
    console.error(err);
  }
};

export const adminApi = async (type, id, action = "none", data) => {
  // console.log("THIS IS MY DATA")
  // console.log(data)
  if (action == "update") {
    try {
      var bodyFormData = new FormData();
      if (type == "text") {
        bodyFormData.append("id", id);
        bodyFormData.append("type", type);
        bodyFormData.append("role", data.role);
        bodyFormData.append("content", data.content);
        bodyFormData.append("cssId", data.cssId);
        bodyFormData.append("link", data.link);
        if (data.image && data.image !== null && data.image instanceof Blob) {
          bodyFormData.append("image", data.image, data.image.name);
        }
        // console.log(data)
        if (data.csv && data.csv !== null) {
          console.log("csv data logging")
          bodyFormData.append("csv", data.csv)
        }
        bodyFormData.append("slug", data.slug);
        const resp = await axios.post(
          severUrl + "blog/admin/update/",
          bodyFormData,
          {
            headers: {
              accept: "application/json",
              "Accept-Language": "en-US,en;q=0.8",
              "Content-Type": `multipart/form-data; boundary=${bodyFormData._boundary}`,
            },
          }
        );
        return resp;
      } else if (type == "citation") {
        bodyFormData.append("id", id);
        bodyFormData.append("type", type);
        bodyFormData.append("text", data.text);
        bodyFormData.append("slug", data.slug);
        const resp = await axios.post(
          severUrl + "blog/admin/update/",
          bodyFormData
        );
        return resp;
      } else if (type == "appendix") {
        console.log(data.indentLevel);
        bodyFormData.append("id", id);
        bodyFormData.append("type", type);
        bodyFormData.append("text", data.text);
        bodyFormData.append("link", data.link);
        bodyFormData.append("indentLevel", data.indentLevel);
        bodyFormData.append("slug", data.slug);
        const resp = await axios.post(
          severUrl + "blog/admin/update/",
          bodyFormData
        );
        return resp;
      }
    } catch (err) {
      console.error(err);
    }
  } else if (action == "insert") {
    try {
      var bodyFormData = new FormData();
      if (type == "text") {
        bodyFormData.append("id", id);
        bodyFormData.append("role", data.role);
        bodyFormData.append("content", data.content);
        bodyFormData.append("cssId", data.cssId);
        bodyFormData.append("link", data.link);
        if (data.image) {
          bodyFormData.append("image", data.image, data.image.name);
        }
        bodyFormData.append("slug", data.slug);
        bodyFormData.append("type", type);
        const resp = await axios.post(
          severUrl + "blog/admin/insert/",
          bodyFormData,
          {
            headers: {
              // 'accept': 'application/json',
              // 'Accept-Language': 'en-US,en;q=0.8',
              "Content-Type": `multipart/form-data; boundary=${bodyFormData._boundary}`,
            },
          }
        );
        return resp;
      } else if (type == "citation") {
        bodyFormData.append("id", id);
        bodyFormData.append("type", type);
        bodyFormData.append("text", data.text);
        bodyFormData.append("slug", data.slug);
        const resp = await axios.post(
          severUrl + "blog/admin/insert/",
          bodyFormData
        );
        return resp;
      } else if (type == "appendix") {
        bodyFormData.append("id", id);
        bodyFormData.append("type", type);
        bodyFormData.append("text", data.text);
        bodyFormData.append("link", data.link);
        bodyFormData.append("indentLevel", data.indentLevel);
        bodyFormData.append("slug", data.slug);
        const resp = await axios.post(
          severUrl + "blog/admin/insert/",
          bodyFormData
        );
        return resp;
      }
    } catch (err) {
      console.error(err);
    }
  } else if (action == "delete") {
    try {
      var bodyFormData = new FormData();
      bodyFormData.append("id", id);
      bodyFormData.append("type", type);
      const resp = await axios.post(
        severUrl + "blog/admin/delete/",
        bodyFormData
      );
      return resp;
    } catch (err) {
      console.error(err);
    }
  } else if (action == "add") {
    try {
      var bodyFormData = new FormData();
      if (type == "text") {
        bodyFormData.append("id", id);
        bodyFormData.append("role", data.role);
        bodyFormData.append("content", data.content);
        bodyFormData.append("cssId", data.cssId);
        bodyFormData.append("link", data.link);
        if (data.image) {
          bodyFormData.append("image", data.image, data.image.name);
        }
        if (data.csv) {
          bodyFormData.append("csv", data.csv)
        }
        bodyFormData.append("slug", data.slug);
        bodyFormData.append("type", type);
        const resp = await axios.post(
          severUrl + "blog/admin/add/",
          bodyFormData,
          {
            headers: {
              accept: "application/json",
              "Accept-Language": "en-US,en;q=0.8",
              "Content-Type": `multipart/form-data; boundary=${bodyFormData._boundary}`,
            },
          }
        );
        return resp;
      } else if (type == "citation") {
        bodyFormData.append("id", id);
        bodyFormData.append("type", type);
        bodyFormData.append("text", data.text);
        bodyFormData.append("slug", data.slug);
        const resp = await axios.post(
          severUrl + "blog/admin/add/",
          bodyFormData
        );
        return resp;
      } else if (type == "appendix") {
        bodyFormData.append("id", id);
        bodyFormData.append("type", type);
        bodyFormData.append("text", data.text);
        bodyFormData.append("link", data.link);
        bodyFormData.append("indentLevel", data.indentLevel);
        bodyFormData.append("slug", data.slug);
        const resp = await axios.post(
          severUrl + "blog/admin/add/",
          bodyFormData
        );
        return resp;
      }
    } catch (err) {
      console.error(err);
    }
  }
};

export default severUrl;
